import { createSlice } from "@reduxjs/toolkit";
import { driverLogout } from "../../apis/pharmacy/logout";

const initialState = {
    loading: false,
    data: null,
    error: null,
    blockedMessage: null
}

const driverLogoutSlice = createSlice({
    name: 'driverLogout',
    initialState,

    reducers: {
        clearLogoutBlockedMessage: (state) => {
            state.blockedMessage = null
        }
    },

    extraReducers: (builder) => {
        builder.addCase(driverLogout.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null,
                blockedMessage: null
            }
        })

        builder.addCase(driverLogout.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
                blockedMessage: null
            }
        })

        builder.addCase(driverLogout.rejected.type, (state, action) => {
            const payload = action.payload
            const status = payload?.status
            let blockedMessage = null
            if (status === 422) {
                const logoutReadiness = payload?.data?.data?.error?.logout_readiness
                if (logoutReadiness?.routes?.length) {
                    blockedMessage = logoutReadiness.routes
                        .map((route) => `${route.route} (${route.pending_rx_count} pending RX)`)
                        .join(', ')
                    blockedMessage = `Drop or hand over these routes first: ${blockedMessage}`
                } else {
                    blockedMessage = payload?.data?.data?.error?.message || payload?.data?.message || 'Logout blocked because active routes are still assigned.'
                }
            }
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload,
                blockedMessage
            }
        })
    }

})

export const { clearLogoutBlockedMessage } = driverLogoutSlice.actions
export default driverLogoutSlice.reducer